import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldUser']),
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldUser'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldUser'])
    },
}